import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess, setError } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import { getDataAtual, getDataFormatada, getData, getDataBanco, getDataHoraBanco, getDataHoraFormatada } from '../utils/dataUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'TRANSFERENCIA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = { datahora_transferencia: getDataAtual() }) {
    return [
        initialize('transferenciaForm', {
			...registro,
			datahora_transferencia: getDataHoraFormatada(registro.datahora_transferencia, 'DD/MM/YYYY HH:mm')
		})
    ];
}

export function getLista(id_empresa) {
    const request = axios.get(`${consts.API_URL}/transferencia?id_empresa=${id_empresa}`);
    return {
        type: 'TRANSFERENCIA_LISTADO',
        payload: request
    };
}

export function getListaGranja(id_empresa) {
    const request = axios.get(`${consts.API_URL}/granja/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'TRANSFERENCIA_GRANJA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaLocal(id_empresa) {
    const request = axios.get(`${consts.API_URL}/local/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'TRANSFERENCIA_LOCAL_SELECT_LISTADO',
        payload: request
    };
}

export function getListaAnimal(id_empresa) {
    const request = axios.get(`${consts.API_URL}/animal/listarAbertos?id_empresa=${id_empresa}`);
    return {
        type: 'TRANSFERENCIA_ANIMAL_SELECT_LISTADO',
        payload: request
    };
}

export function getListaItens(id_transferencia, id_empresa) {
    const request = axios.get(`${consts.API_URL}/transferenciaItem?id_transferencia=${id_transferencia}&id_empresa=${id_empresa}`);
    return {
        type: 'TRANSFERENCIA_ITEM_LISTADO',
        payload: request
    };
}

export function salvar(registro) {

    return (dispatch, getState) => {
        axios.post(`${consts.API_URL}/transferencia`, {
			...registro,
			datahora_transferencia: getDataHoraBanco(registro.datahora_transferencia),
			id_empresa: getState().auth.usuario.id_empresa
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(getState().auth.usuario.id_empresa));
            dispatch(setModoTela('cadastro'));
			if (!registro.id) {
				registro.id = resp.data;
			}
			registro.datahora_transferencia = getDataHoraBanco(registro.datahora_transferencia);
			dispatch(initForm(registro));
			dispatch(getListaAnimal(getState().auth.usuario.id_empresa));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/transferencia?id=${registro.id}`)
            .then(resp => {
                setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(getState().auth.usuario.id_empresa));
                dispatch(setModoTela('lista'));
            })
            .catch(e => {
                setErroAPI(e);
            });
    };
}

export function adicionarItem(registro) {

    return (dispatch, getState) => {
        axios.post(`${consts.API_URL}/transferenciaItem`, {
			...registro,
			id_empresa: getState().auth.usuario.id_empresa
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaItens(registro.id_transferencia, getState().auth.usuario.id_empresa));
			dispatch(getListaAnimal(getState().auth.usuario.id_empresa));
			dispatch(getLista());
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function alterarItem(registro) {

    return (dispatch, getState) => {
        axios.post(`${consts.API_URL}/transferenciaItem`, {
			...registro,
			id_empresa: getState().auth.usuario.id_empresa
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaItens(registro.id_transferencia, getState().auth.usuario.id_empresa));
			dispatch(getListaAnimal(getState().auth.usuario.id_empresa));
			dispatch(getLista(getState().auth.usuario.id_empresa));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function removerItem(registro) {

    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/transferenciaItem?id=${registro.id}`, {
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaItens(registro.id_transferencia, getState().auth.usuario.id_empresa));
			dispatch(getListaAnimal(getState().auth.usuario.id_empresa));
			dispatch(getLista(), getState().auth.usuario.id_empresa);
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function ratearPeso(id_empresa, id_transferencia, peso) {

	return async (dispatch, getState) => {
		let listaItens = [];
		await axios.get(`${consts.API_URL}/transferenciaItem?id_empresa=${id_empresa}&id_transferencia=${id_transferencia}`)
		.then(result => {
			listaItens = result.data;
		}).catch(e => {
			console.log(e);
		});
		let rateio = parseFloat((peso / listaItens.length).toFixed(4));
		let rateado = 0;
		listaItens = listaItens.map(item => {
			item.peso = rateio;
			rateado += rateio;
			return item;
		});
		let resto  = parseFloat((peso - rateado).toFixed(4));
		while (resto != 0) {
			listaItens = listaItens.map(item => {
				if (resto >= 0.0001) {
					item.peso += 0.0001;
					resto -= 0.0001;
				} else if (resto <= -0.0001) {
					item.peso -= 0.0001;
					resto += 0.0001;
				} else {
					resto = 0;
				}
				return item;
			});
		}
		for (var i = 0; i < listaItens.length; i++) {
			let item = listaItens[i];
			await axios.post(`${consts.API_URL}/transferenciaItem`, {
				...item
			}).then(result => {
	        }).catch(e => {

	        });
		}

		setSuccess('Operação Realizada com sucesso.');
		dispatch(getListaItens(id_transferencia, getState().auth.usuario.id_empresa));
		dispatch(getListaAnimal(getState().auth.usuario.id_empresa));
		dispatch(getLista(getState().auth.usuario.id_empresa));

	}
}
